import join from 'url-join';

import type { BuyItAgainApiResponse } from '@libs/common-types';
import { getAccessToken, getLocale } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export type GetBuyItAgainRecommendationsInput = {
    placement: 'homepage' | 'incart' | 'checkout';
    minCount: number;
    maxCount: number;
    inventoryList: string[];
    excludes: string[];
    saleIndicator: boolean;
};

export async function getBuyItAgainRecommendations(
    input: GetBuyItAgainRecommendationsInput
): Promise<BuyItAgainApiResponse> {
    if (!getAccessToken()) {
        throw new Error('No access token found');
    }

    const searchParams = new URLSearchParams({
        locale: getLocale(),
        placement: input.placement,
        minCount: String(input.minCount),
        maxCount: String(input.maxCount),
        saleIndicator: String(input.saleIndicator),
        ...(input.inventoryList.length && { inventoryList: input.inventoryList.join(',') }),
        ...(input.excludes.length && { excludes: input.excludes.join(',') }),
    });

    const result = await cweaClient.get<BuyItAgainApiResponse>(
        join(CWEA_ENDPOINTS.buyItAgain.getBuyItAgainRecommendations, `?${searchParams.toString()}`),
        { useOldFetch: true }
    );

    if (!result) {
        throw new Error(`${CWEA_ENDPOINTS.buyItAgain.getBuyItAgainRecommendations} returned null`);
    }

    return result;
}
